module.exports = "/static/assets/3d01caa7b3aaa53cfd249a1a7a22f7fb.png";